import Rankings from './Rankings';

export default Rankings;
